import ReactGA4 from 'react-ga4';

// Replace with your actual GA4 Measurement ID from Google Analytics
const MEASUREMENT_ID = 'G-86KVS7X78F';

// Initialize GA
export const initGA = () => {
  // GA4 debug mode
  window.dataLayer = window.dataLayer || [];
//   window.gtag = function() { dataLayer.push(arguments); }
//   gtag('js', new Date());
//   gtag('config', 'G-86KVS7X78F', {
//     debug_mode: true,
//     send_page_view: false // We'll handle this manually
//   });
  
  ReactGA4.initialize('G-86KVS7X78F');
  console.log('GA initialized with debug mode');
};

// Track page views
export const trackPageView = (path) => {
  ReactGA4.send({ hitType: "pageview", page: path });
  console.log(`Page view tracked: ${path}`);
};

// Track user authentication
export const trackUserLogin = (userId, userRole) => {
  // Don't include PII (Personally Identifiable Information)
  ReactGA4.event({
    category: 'User',
    action: 'Login',
    label: userRole || 'Teacher' // e.g., Teacher, Admin, etc.
  });
};

// Track class creation
export const trackClassCreation = (classType) => {
  ReactGA4.event({
    category: 'Class',
    action: 'Create',
    label: classType // e.g., Regular, SET, Trial, SpecialEd
  });
};

// Track assessment assignments
export const trackAssessmentAssignment = (assessmentType, studentCount) => {
  ReactGA4.event({
    category: 'Assessment',
    action: 'Assign',
    label: assessmentType,
    value: studentCount // Number of students assigned
  });
};

// Track student additions
export const trackStudentAddition = (method, count) => {
  ReactGA4.event({
    category: 'Student',
    action: 'Add',
    label: method, // e.g., 'Manual', 'Import', 'Bulk'
    value: count
  });
};

// Track result views
export const trackResultView = (resultType) => {
  ReactGA4.event({
    category: 'Results',
    action: 'View',
    label: resultType // e.g., 'Individual', 'Class', 'All'
  });
};

// Track feature usage
export const trackFeatureUsage = (feature) => {
  ReactGA4.event({
    category: 'Feature',
    action: 'Use',
    label: feature // e.g., 'RTI', 'Reports', 'Recommendations'
  });
};

// Track errors
export const trackError = (errorSource, errorMessage) => {
  ReactGA4.event({
    category: 'Error',
    action: errorSource,
    label: errorMessage?.substring(0, 100) // Truncate long messages
  });
};

// Track user engagement time
export const trackEngagementTime = (timeInSeconds, pageOrFeature) => {
  ReactGA4.event({
    category: 'Engagement',
    action: 'Time Spent',
    label: pageOrFeature,
    value: Math.round(timeInSeconds) // Round to nearest second
  });
};

// Track user interactions with SEN features
export const trackSENFeatureUsage = (feature, actionType) => {
  ReactGA4.event({
    category: 'SEN',
    action: actionType,
    label: feature // e.g., 'Watchlist', 'Reports', 'Handover'
  });
};

// Track report generation
export const trackReportGeneration = (reportType) => {
  ReactGA4.event({
    category: 'Report',
    action: 'Generate',
    label: reportType // e.g., 'Class', 'Student', 'SENCO'
  });
};

// Track colleague invitations
export const trackColleagueInvitation = (invitationCount) => {
  ReactGA4.event({
    category: 'Colleague',
    action: 'Invite',
    value: invitationCount
  });
};

// Example implementation of timing for performance monitoring
export const measureTiming = (category, variable, timeInMs) => {
  ReactGA4.timing({
    category: category,
    variable: variable,
    value: timeInMs // time in milliseconds
  });
};